// extracted by mini-css-extract-plugin
export default {"root":"YYnEzb","bg":"PhyN2E"};